export default (props = {}) => <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none"{...props}>
    <g id="ArrowDownFilled">
    <path d="M6.79241 7.97063C6.3921 8.49064 5.60789 8.49064 5.20759 7.97063L0.311169 1.60999C-0.195028 0.952424 0.273737 -1.19999e-06 1.10358 -1.12744e-06L10.8964 -2.71323e-07C11.7263 -1.98776e-07 12.195 0.952425 11.6888 1.60999L6.79241 7.97063Z" fill="#EEEEEE"/>
</g>    
</svg>
